module.exports = __webpack_public_path__ + "media/images/web/favicon/apple-icon-152x152-6bf8d03a06af4675df581fee72ba09e7.png";